import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropdownModel, BreadCrumbModel } from 'lib/ng2-sapmp/src/ui-components';
// import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { TransactionService } from '../shared/providers/transaction.service';
import { ENV } from 'config';
import { DatePickerComponent, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';

export class DateRange {
  constructor(public id: number, public name: string) { }
}

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent implements OnInit {
  singleDevice: boolean;
  public errorMessage: string;
  public pageJson: any;
  public formInputs: Array<any>;
  public fromDate: any;
  public toDate: any;
  dateRanges = [
    new DateRange(1, 'Last 90 days'),
    new DateRange(2, 'Last 60 days'),
    new DateRange(3, 'Last 30 days'),
    new DateRange(4, 'Custom date range')
  ];

  public fan: string;
  public showDate: boolean;
  public dateRangeForm: any;
  public accountType: string;
  public selectedCtn: string;
  public dateRange: any;
  public preselectValue: any;
  public datePickerComponent: any;
  constructor(private transactionService: TransactionService,
    private stepIndicator: StepIndicatorService,
    private utilities: UtilityService,
    private router: Router,
    private route: ActivatedRoute,
    private utilityService: UtilityService) {
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];

    this.dateRangeForm = new FormGroup({
      dateRange: new FormControl('', [<any>Validators.required]),
      From: new FormControl('', [<any>Validators.required]),
      To: new FormControl('', [<any>Validators.required])
    });
    this.initpage();
    this.formInputs = [{
      id: 'from',
      title: 'From',
      dateInput: this.createDatePickerInput('from'),
      toolTipText: 'Start date of report'
    }, {
      id: 'to',
      title: 'To',
      dateInput: this.createDatePickerInput('to'),
      toolTipText: 'End date of report'
    }];
    this.stepIndicator.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicator.setVisibility(true);

    this.transactionService.createPageLoadProperties('DATE_RANGE', 'dateRange');

  }

  initpage() {
    const reportRequest = this.transactionService.getReportModel();

    this.accountType = reportRequest.accountType;

    this.singleDevice = reportRequest.accountType === 'singleDevice';

    if (this.singleDevice) {
      this.fan = reportRequest.selectedCtn ? reportRequest.selectedCtn.fan : '';
      this.selectedCtn = reportRequest.selectedCtn ? reportRequest.selectedCtn.ctn.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1.$2.$3') : '';
    } else {
      this.fan = reportRequest.selectedFan ? reportRequest.selectedFan.name : '';
    }

    this.updateDateRangeOption(reportRequest.dateRange || this.dateRanges[0]);
    this.dateRangeForm.controls['dateRange'].setValue(reportRequest.dateRange || this.dateRanges[0]);

  }
  processNext() {
    const reportRequest = this.transactionService.getReportModel();
    reportRequest.startDate = this.fromDate;
    reportRequest.endDate = this.toDate;
    reportRequest.dateRange = this.dateRange;
    this.transactionService.setReportModel(reportRequest);
    this.router.navigate(['review'], { relativeTo: this.route.parent });
  }

  onInput($event) {
    $event.preventDefault();
  }

  backToPrevious(event) {
    event.preventDefault();
    this.router.navigate(['reports/transaction/reportType']);

  }
  updateDateRangeOption(dropDownSelect) {
    if (dropDownSelect && dropDownSelect.id === 4) {
      this.showDate = true;
    }else {
      this.showDate = false;
    }
    /*set back the previously selected dates in picker */
    const reportRequest = this.transactionService.getReportModel();
    this.selectDateRangeOption(dropDownSelect);
    if (dropDownSelect.id === 4) {
      this.toDate = reportRequest.endDate;
      this.fromDate = reportRequest.startDate;
      this.dateRange = dropDownSelect;
    }else {
      this.selectDateRangeOption(dropDownSelect);
    }
  }

  /*update the toDate,fromDate and showDate*/
  selectDateRangeOption(dropDownSelect) {
    this.showDate = false;
    if (dropDownSelect.id === 1) {
      this.fromDate = new Date(new Date().setDate(new Date().getDate() - 90));
    } else if (dropDownSelect.id === 2) {
      this.fromDate = new Date(new Date().setDate(new Date().getDate() - 60));
    } else if (dropDownSelect.id === 3) {
      this.fromDate = new Date(new Date().setDate(new Date().getDate() - 30));
    }else {
      this.showDate = true;
    }
    this.toDate = new Date();
    this.dateRange = dropDownSelect;
  }

  createDropDownOptions(name, value): DropdownModel {
    const dropDown = {
      'name': name,
      'value': value
    };
    return dropDown;
  }


  createDatePickerInput(id: string) {

    const minDate = new Date(new Date().setDate(new Date().getDate() - 360));
    const maxDate = new Date();
    const selectedDate = id === 'to' ? this.toDate || maxDate : this.fromDate || minDate;
    const dateInput = {
      id: id,
      minDate: minDate,
      maxDate: maxDate,
      datePickerLabel: '',
      selectedDate: selectedDate,
      ariaLabel: {
        open: 'Show date picker',
        close: 'Hide date picker'
      },
      showError: false
    };
    if (selectedDate) {
      dateInput.selectedDate = new Date(selectedDate);
    }
    return dateInput;
  }

  onDateChange(dateObj: any) {
    if (dateObj.id === 'from') {
      this.fromDate = dateObj.date;
      this.formInputs[1].dateInput.maxDate = new Date(dateObj.date).setDate(new Date(dateObj.date).getDate() + 90) >
        new Date().getTime() ? new Date() : new Date(new Date(dateObj.date).setDate(new Date(dateObj.date).getDate() + 90));
      this.formInputs[1].dateInput.minDate = dateObj.date;
    } else {
      this.toDate = dateObj.date;
      this.formInputs[0].dateInput.maxDate = dateObj.date;
      this.formInputs[0].dateInput.minDate = new Date(new Date(dateObj.date).setDate(new Date(dateObj.date).getDate() - 90));
    }
  }

}
